import { render, staticRenderFns } from "./AltaTecnicoPantalla.vue?vue&type=template&id=8bc04828&"
import script from "./AltaTecnicoPantalla.vue?vue&type=script&lang=ts&"
export * from "./AltaTecnicoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8bc04828', component.options)
    } else {
      api.reload('8bc04828', component.options)
    }
    module.hot.accept("./AltaTecnicoPantalla.vue?vue&type=template&id=8bc04828&", function () {
      api.rerender('8bc04828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltaTecnico/AltaTecnicoPantalla.vue"
export default component.exports